import React, { useEffect, useState } from 'react';
import { Modal, Spin } from 'antd';
import './format.scss';
import BackSVG from '@web-common/components/UI/Icons/svgs/Back';
import { getIn18Text } from 'api';
let GdEditorSdk;
if (typeof window !== 'undefined') {
}
const MailFormatEdit = props => {
    const { onCancel, visible, onCompleted, groupId, mfId, onBack } = props;
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        if (GdEditorSdk) {
            setLoading(true);
            const gdEditorSDK = new GdEditorSdk({
                container: '.iframe-wrap',
                appId: 'wang_yi_ling_xi_ban_gong_poster_editor',
                autoClose: true,
                buttonText: getIn18Text('WANCHENG'),
                onCompleted(file) {
                    const { files } = file;
                    onCancel && onCancel();
                    onCompleted && onCompleted(files);
                },
                onTempletLoaded(editor) {
                    setLoading(false);
                },
                onClose() { },
            });
            const ext = groupId
                ? {
                    thirdCateId: groupId || '',
                    id: mfId || '',
                }
                : {
                    mode: 'create',
                };
            gdEditorSDK.open({
                ext,
            });
            return () => {
                gdEditorSDK === null || gdEditorSDK === void 0 ? void 0 : gdEditorSDK.close();
            };
        }
    }, []);
    return (React.createElement(Modal, { className: "mailformat-modal", width: "80%", title: React.createElement("div", { className: "mailformat-modal-title-wrap" },
            React.createElement("span", { onClick: onBack, className: "mailformat-icon-back" },
                React.createElement(BackSVG, null)),
            React.createElement("span", null, getIn18Text('BIANJIYOUJIANMO'))), footer: null, maskClosable: false, keyboard: false, centered: true, visible: visible, onCancel: onCancel },
        React.createElement(Spin, { spinning: loading },
            React.createElement("div", { className: "iframe-wrap", style: {
                    width: '100%',
                    height: '80vh',
                    minHeight: '500px',
                    maxHeight: '900px',
                } }))));
};
export default MailFormatEdit;
